import { useState, useRef } from 'react';
import { forwardRef } from 'react';
import "../assets/css/FAQ.css";

const faqs = [
    {
        question: "How much does it cost to join as a restaurant partner?",
        answer: "It's completely free to join! We only charge a small commission on successful orders. Plus, your first 3 months are commission-free when you sign up this month."
    },
    {
        question: "How long does it take to set up my restaurant on the platform?",
        answer: "Most restaurants are up and running within 15 minutes! Simply register, upload your menu, add photos, and you're ready to start receiving orders."
    },
    {
        question: "Do you provide delivery drivers or do I need my own?",
        answer: "We have a network of reliable delivery partners who will handle all deliveries for you. You don't need to worry about hiring drivers or managing deliveries."
    },
    {
        question: "How do I receive payments for my orders?",
        answer: "Payments are processed securely and automatically transferred to your bank account weekly. You can track all your earnings in real-time through our partner dashboard."
    },
    {
        question: "What areas do you currently serve?",
        answer: "We're currently operating in major metropolitan areas and expanding rapidly. Contact us to check if we serve your area or to request expansion to your location."
    },
    {
        question: "Can I control my restaurant's availability and hours?",
        answer: "Absolutely! You have full control over your operating hours, menu availability, and can pause orders anytime through our easy-to-use dashboard."
    },
    {
        question: "What support do you provide to restaurant partners?",
        answer: "We provide 24/7 customer support, a dedicated account manager, marketing assistance, and detailed analytics to help you grow your business."
    },
    {
        question: "How do customers pay for their orders?",
        answer: "Customers can pay through multiple secure methods including credit/debit cards, digital wallets, and cash on delivery. All payments are processed securely."
    }
];

const FAQ = forwardRef<HTMLElement, {}>((props, ref) => {

    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

    const toggleFAQ = (index: number) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    return (
        <section className="all-main-section" ref={ref}>
            <div className="all-main-section-content-wrapper">
                <h2 className="all-main-title" style={{ textAlign: "center" }}>
                    Frequently Asked <span>Questions</span>
                </h2>

                {faqs.map((faq, index) => {
                    const isOpen = openIndex === index;

                    return (
                        <div
                            key={index}
                            className={`faq-card ${isOpen ? "open" : ""}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="faq-header">
                                <span className="faq-question">{faq.question}</span>
                                <span className={`faq-icon ${isOpen ? "rotate" : ""}`}>
                                    {isOpen ? "−" : "+"}
                                </span>
                            </div>

                            <div
                                ref={(el) => {
                                    contentRefs.current[index] = el;
                                }}
                                className="faq-content"
                                style={{
                                    height: isOpen ? contentRefs.current[index]?.scrollHeight : 0,
                                }}
                            >
                                <p>{faq.answer}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
});

export default FAQ;